module.exports = __webpack_public_path__ + "img/img-business-global-step-02.png";